import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components'
import { Col, Row, Button, Container, Card } from 'react-bootstrap';
import './chart.scss';
import { ProgressBar } from "react-bootstrap"; 
import "bootstrap/dist/css/bootstrap.min.css";




const secretKeysList = ["PAT", "Token", "AWS Access Key", "Anypoint Password", "Anypoint Client Secret"];
const Chart = (props) => (
  <Row xs={12} className={"chartContainer " + props.theme} onClick={props.onClick}>


    {
      Object.entries(props.chartData).map(([key, value]) => {

        return (<Col xs={props.gridval}>
          <span className='chartTitle' >
            {key}
          </span>
          <span className='chartValue' >
            {secretKeysList.includes(key) ? <input className="table-apssword" type="password" value={value}></input> : value}
          </span>  </Col>)
      })
    }
  </Row>

)
export default Chart;

// const MultiChart = (props) => (
//   <Row xs={12} className= {"chartContainer " + props.theme} onClick={props.onClick}>


//      {

//        Object.entries(props.chartData).map(([key,value])=>{
//         let percentage = (value== undefined)? "0%" :value.percentage
//         let bgcolour = (value == undefined)? '#ed2323':(value.status== 'error')? '#f80a0a':'#327a43'
//         console.log("Props",props)

//        return( 
//         <> 
//        <Col xs={props.gridval}>
//                   <span className='chartTitle'>
//                     {key}
//                   </span>
//      </Col>
//                    <Col xs={props.gridval}>
//                   <span className='chartValue'>
//                 <div class = "mainDiv">
//                      {/* <div class = "childDiv" style={{"width" : `${props.gridval}%`}}> */}
//                      <div class = "childDiv" style={{"width" : `${percentage}`, "backgroundColor": `${bgcolour}`}}>

//                         <span class = "text"> {percentage} </span>
//                       </div>
//                   </div>
//                   </span>
//                   </Col>
//                   </>  
//        )


//       })
//      } 
//   </Row>

//   )



const MultiChart = (props) => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleEdit = (projectName, e) => {
    e.stopPropagation();
    setOpenDropdown(null);
    if (props.onEdit) {
      props.onEdit(projectName);
    }
  };

  const handleDelete = (projectName, e) => {
    e.stopPropagation();
    setOpenDropdown(null);
    if (props.onDelete) {
      props.onDelete(projectName);
    }
  };

  return (
    <>
      <Row xs={12} className={"chartContainer " + props.theme}>
        {/* Header Row */}
        <Col xs={5}>
          <span className='headerTitle'>
            {props.container}
          </span>
        </Col>
        <Col xs={3} />
        <Col xs={3}>
          <span className='headerTitle'>
            Status
          </span>
        </Col>
        <Col xs={1}>
          <span className='headerTitle'>
            Actions
          </span>
        </Col>

        {/* Project Rows */}
        {props.Templates.map((projName, index) => {
          const statusData = (props.status !== undefined && props.status.length !== 0) 
            ? props.status.filter(status => status.exactPjtName === props.projectName + '-' + projName) 
            : [];

          let status = statusData.pop();
          const fullProjectName = props.projectName + '-' + projName;

          return (
            <React.Fragment key={index}>
              <Col xs={5}>
                <span 
                  className='chartValue' 
                  style={{ 'cursor': 'pointer' }} 
                  onClick={() => props.getProjectStatus(fullProjectName)}
                >
                  {fullProjectName}
                </span>
              </Col>
              <Col xs={3} />
              <Col xs={3}>
                <span className='chartValue'>
                  {status === undefined ? (
                    <ProgressBar label={"not started"} now={100} variant="info" />
                  ) : status.status === 'error' ? (
                    <ProgressBar striped now={100} label={`failed`} animated variant="danger" />
                  ) : status.status === 'releasecompleted' ? (
                    <ProgressBar striped now={100} label={`release created`} variant="success" />
                  ) : (
                    <ProgressBar striped now={100} label={`in progress`} animated variant="success" />
                  )}
                </span>
              </Col>
              <Col xs={1}>
                {/* Three-dot menu for each project */}
                <div className="project-actions-menu" ref={openDropdown === fullProjectName ? dropdownRef : null}>
                  <button
                    className="three-dot-btn-multi"
                    onClick={(e) => {
                      e.stopPropagation();
                      setOpenDropdown(openDropdown === fullProjectName ? null : fullProjectName);
                    }}
                  >
                    ⋮
                  </button>

                  {openDropdown === fullProjectName && (
                    <div className="dropdown-menu-multi">
                      <button 
                        className="dropdown-item-multi" 
                        onClick={(e) => handleEdit(fullProjectName, e)}
                      >
                        <span className="icon">✏️</span> Edit
                      </button>
                      <button 
                        className="dropdown-item-multi delete" 
                        onClick={(e) => handleDelete(fullProjectName, e)}
                      >
                        <span className="icon">🗑️</span> Delete
                      </button>
                    </div>
                  )}
                </div>
              </Col>
            </React.Fragment>
          );
        })}
      </Row>
    </>
  );
};

export { MultiChart };